export const ro = {
    LEFT: 'Stânga: Deplasa la ziua precedentă.',
    RIGHT: 'Dreapta: deplasați-vă la următoarea zi.',
    DOWN: 'Jos: trece la rândul următor.',
    UP: 'Up: deplasați-vă la rândul precedent.',
    PGUP: 'PgUp: a trece la luna anterioară.',
    PGDOWN: 'PgDown: trece la luna următoare.',
    HOME: 'Acasă: Muta cu anul precedent.',
    END: 'Scop: a trece la următorul an.',
    ESC: 'Esc/Azi/Închidere: închideți calendar.',
    TITLE: 'Keyboard Instrucțiuni'
};
